/* eslint-env node */
require('./src/styles/global.css')

export { wrapPageElement } from './gatsby-shared'
